/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentPrizeTier } from './TournamentPrizeTier';
import {
    TournamentPrizeTierFromJSON,
    TournamentPrizeTierFromJSONTyped,
    TournamentPrizeTierToJSON,
    TournamentPrizeTierToJSONTyped,
} from './TournamentPrizeTier';
import type { UpdateTournamentPrizeBreakdownItem } from './UpdateTournamentPrizeBreakdownItem';
import {
    UpdateTournamentPrizeBreakdownItemFromJSON,
    UpdateTournamentPrizeBreakdownItemFromJSONTyped,
    UpdateTournamentPrizeBreakdownItemToJSON,
    UpdateTournamentPrizeBreakdownItemToJSONTyped,
} from './UpdateTournamentPrizeBreakdownItem';

/**
 * 
 * @export
 * @interface UpdateTournamentPrizePool
 */
export interface UpdateTournamentPrizePool {
    /**
     * 
     * @type {number}
     * @memberof UpdateTournamentPrizePool
     */
    fixedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTournamentPrizePool
     */
    sponsorContribution?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTournamentPrizePool
     */
    total?: number;
    /**
     * Guaranteed minimum prize pool in USD dollars. Devour tops the pool up to this figure when entry fees fall short and pays nothing when they cover it — the pool is never less than this, and never this PLUS entry fees. Requires a payoutTableId. Converted to Fuel at distribution time using the Fuel price at payout.
     * @type {number}
     * @memberof UpdateTournamentPrizePool
     */
    guaranteedPoolUsd?: number;
    /**
     * Rank rewards granted by finishing position. Independent of the payout table.
     * @type {Array<TournamentPrizeTier>}
     * @memberof UpdateTournamentPrizePool
     */
    tiers?: Array<TournamentPrizeTier>;
    /**
     * 
     * @type {string}
     * @memberof UpdateTournamentPrizePool
     */
    type?: UpdateTournamentPrizePoolTypeEnum;
    /**
     * 
     * @type {Array<UpdateTournamentPrizeBreakdownItem>}
     * @memberof UpdateTournamentPrizePool
     */
    breakdown?: Array<UpdateTournamentPrizeBreakdownItem>;
}


/**
 * @export
 */
export const UpdateTournamentPrizePoolTypeEnum = {
    FIXED: 'FIXED'
} as const;
export type UpdateTournamentPrizePoolTypeEnum = typeof UpdateTournamentPrizePoolTypeEnum[keyof typeof UpdateTournamentPrizePoolTypeEnum];


/**
 * Check if a given object implements the UpdateTournamentPrizePool interface.
 */
export function instanceOfUpdateTournamentPrizePool(value: object): value is UpdateTournamentPrizePool {
    return true;
}

export function UpdateTournamentPrizePoolFromJSON(json: any): UpdateTournamentPrizePool {
    return UpdateTournamentPrizePoolFromJSONTyped(json, false);
}

export function UpdateTournamentPrizePoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTournamentPrizePool {
    if (json == null) {
        return json;
    }
    return {
        
        'fixedAmount': json['fixedAmount'] == null ? undefined : json['fixedAmount'],
        'sponsorContribution': json['sponsorContribution'] == null ? undefined : json['sponsorContribution'],
        'total': json['total'] == null ? undefined : json['total'],
        'guaranteedPoolUsd': json['guaranteedPoolUsd'] == null ? undefined : json['guaranteedPoolUsd'],
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(TournamentPrizeTierFromJSON)),
        'type': json['type'] == null ? undefined : json['type'],
        'breakdown': json['breakdown'] == null ? undefined : ((json['breakdown'] as Array<any>).map(UpdateTournamentPrizeBreakdownItemFromJSON)),
    };
}

export function UpdateTournamentPrizePoolToJSON(json: any): UpdateTournamentPrizePool {
    return UpdateTournamentPrizePoolToJSONTyped(json, false);
}

export function UpdateTournamentPrizePoolToJSONTyped(value?: UpdateTournamentPrizePool | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fixedAmount': value['fixedAmount'],
        'sponsorContribution': value['sponsorContribution'],
        'total': value['total'],
        'guaranteedPoolUsd': value['guaranteedPoolUsd'],
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(TournamentPrizeTierToJSON)),
        'type': value['type'],
        'breakdown': value['breakdown'] == null ? undefined : ((value['breakdown'] as Array<any>).map(UpdateTournamentPrizeBreakdownItemToJSON)),
    };
}

